export enum UserStatuses {
  true = 'Active',
  false = 'Archived',
}

export enum UserRoles {
  user = 'QC Inspector',
  manager = 'Manager',
  admin = 'Admin',
}
